// @ts-nocheck
// @ts-ignore
// eslint-disable-next-line no-unused-expressions
/*
    Copyright 2023 AShield Technologies

    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
// import {logger} from "./logger";
const logger = console;
let enablelogs = true;

function arrayBufferToString(arrayBuffer) {
  return String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
}
// function for cahnging to ArrayBuffer
function toArrayBuffer(e) {
  const t = e.replace(/-/g, '+').replace(/_/g, '/'),
    n = (4 - (t.length % 4)) % 4,
    r = t.padEnd(t.length + n, '='),
    o = atob(r),
    a = new ArrayBuffer(o.length),
    i = new Uint8Array(a);
  for (let e = 0; e < o.length; e++) i[e] = o.charCodeAt(e);
  return a;
}

// function for changing ArrayBuffer to base64
function arrayBufferToBase64(e) {
  const t = new Uint8Array(e);
  let n = '';
  for (const e of t) n += String.fromCharCode(e);
  return btoa(n).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

function idStringToArrayBuffer(e) {
  for (let i = 0; i < e.length; i++) {
    e[i].id = toArrayBuffer(e[i].id);
  }
  return e;
}
function printlog(msg, obj) {
  if (enablelogs) {
    if (obj) {
      console.log(msg, JSON.stringify(obj));
    } else {
      console.log(msg);
    }
  }
}
// var serverBaseUrl = 'http://localhost:9090/Ashield';
var serverBaseUrl = 'https://poc.ashieldhub.com/Ashield';
// var serverBaseUrl = "https://saas.ashieldhub.com/Ashield";
var algo = 'SHA-256';
/*sbUrl : Server URL from which the request will be proxied
algo : Alogrithm same which will be decided from server
*/
async function init(sbUrl, alg) {
  algo = alg;
  // serverBaseUrl = sbUrl;
}
function parseJwt(token) {
  let base64Url = token.split('.')[1];

  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  while (base64.length % 4) {
    base64 += '=';
  }

  const jsonPayload = new TextDecoder().decode(
    Uint8Array.from(atob(base64), (c) => c.charCodeAt(0)),
  );

  return JSON.parse(jsonPayload);
}
async function checkWebAuthnCapability() {
  const userAgent = window.navigator.userAgent;
  let os = '';
  let isWidget = false;
  if (userAgent.includes('GSA/')) {
    isWidget = true;
  }
  if (/Android/i.test(userAgent)) {
    os = 'Android';
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    os = 'iOS';
  } else if (/Win/i.test(userAgent)) {
    os = 'Windows';
  } else if (/Mac/i.test(userAgent)) {
    os = 'MacOS';
  } else if (/Linux/i.test(userAgent)) {
    os = 'Linux';
  }

  //Update UI to reflect availability of platform authenticator
  if (
    !window.PublicKeyCredential ||
    typeof window.PublicKeyCredential
      .isUserVerifyingPlatformAuthenticatorAvailable !== 'function'
  ) {
    //BROWSER INCOMPATIBLE
    printlog('Browser Incompatible');
    return 'CL_ERR_1006';
  } else {
    // OS INCOMPATIBLE OR PLATFORM AUTHENTICATOR DISABLED
    try {
      let available =
        await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
      printlog(
        'Availability of Platform Authenticator in Register function : ',
        {
          available: available,
        },
      );
      if (!available && os == 'iOS' && isWidget) {
        printlog('Platform Authenticator Unavailable in IOS Widget');
        return 'CL_ERR_1011';
      } else if (!available) {
        return 'CL_ERR_1005';
      }
    } catch (error) {
      return 'CL_ERR_1005';
    }
  }
  return '';
}
async function decryptResponse(epik, encryptedServerResponse) {
  try {
    // Import private key
    const pk = await window.crypto.subtle.importKey(
      'pkcs8',
      toArrayBuffer(epik),
      {
        name: 'RSA-OAEP',
        hash: { name: algo },
      },
      true,
      ['decrypt'],
    );

    // Decrypt JWT
    const decdata = await window.crypto.subtle.decrypt(
      {
        name: 'RSA-OAEP',
      },
      pk,
      toArrayBuffer(encryptedServerResponse),
    );

    // Convert ArrayBuffer -> string
    const decryptedServerResponse = arrayBufferToString(decdata);

    printlog('Decrypted Response : ', { resp: decryptedServerResponse });

    return decryptedServerResponse;
  } catch (err) {
    console.error('JWT decryption failed:', err);
    throw err;
  }
}
function isMobileDevice() {
  if (navigator.userAgentData?.mobile) {
    return true;
  }

  if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    return true;
  }

  if (window.matchMedia('(pointer: coarse)').matches) {
    return true;
  }

  if (navigator.maxTouchPoints > 1) {
    return true;
  }
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  if (width < 768) {
    return true;
  }

  return false;
}

async function getDeviceIntelligence() {
  let browser = '';
  let browserVersion = '';
  let platform = '';
  let platformVersion = '';
  let bitness = '';
  let architecture = '';
  let deviceMemory = '';
  let hardwareConcurrency = '';
  let renderer = '';
  let pixelratio = '';
  let winLength = '';
  let maxTouchpoints = '';
  let canvasFP = '';
  let dfp = '';
  function parseUserAgent(ua) {
    let field1 = ''; // OS
    let field2 = ''; // Bitness
    let field3 = ''; // Architecture
    let field4 = ''; // Browser
    let field5 = ''; // Browser Version

    // ----------------------------
    // OS
    // ----------------------------
    let match = ua.match(/\((Windows NT [^;]+|Macintosh; ([^)]+))/);

    if (match) {
      if (match[1].startsWith('Windows NT')) {
        field1 = match[1];
      } else {
        // "Macintosh; Intel Mac OS X 10_15_7"
        field1 = match[2].replace(/^Intel\s+/, '');
      }
    }

    // ----------------------------
    // Bitness
    // ----------------------------
    const win64 = ua.match(/\bWin(\d+)\b/i);
    if (win64) {
      field2 = win64[1];
    } else if (/Safari/i.test(ua)) {
      // Safari is 64-bit on supported macOS
      field2 = '64';
    }

    // ----------------------------
    // Architecture
    // ----------------------------
    // Architecture
    if (/\bx64\b/i.test(ua)) {
      field3 = 'x64';
    } else if (/\barm64\b/i.test(ua)) {
      field3 = 'arm64';
    } else if (/Safari/i.test(ua)) {
      field3 = 'arm'; // Always "arm" for Safari
    }

    // ----------------------------
    // Browser & Version
    // ----------------------------
    let firefox = ua.match(/Firefox\/([\d.]+)/i);
    if (firefox) {
      field4 = 'Firefox';
      field5 = firefox[1];
    } else {
      let safari = ua.match(/Version\/([\d.]+).*Safari/i);
      if (safari && !/Chrome|Chromium|Edg|OPR/i.test(ua)) {
        field4 = 'Safari';
        field5 = safari[1];
      }
    }

    return {
      field1,
      field2,
      field3,
      field4,
      field5,
    };
  }

  if (navigator.userAgentData) {
    const uanew = await navigator.userAgentData.getHighEntropyValues([
      'architecture',
      'bitness',
      'platformVersion',
      'uaFullVersion',
      'fullVersionList',
    ]);
    //const uanew = "";

    console.log('New UA', uanew);
    if (uanew.fullVersionList.length > 0) {
      const browserObj = uanew.fullVersionList.find(
        (item) => item.brand !== 'Chromium' && !item.brand.startsWith('Not'),
      );
      //browser = uanew.fullVersionList[1].brand;
      if(!browserObj){
        console.log('BOT Detected!');
      browser = uanew.brands[1].brand;
      browserVersion = uanew.brands[1].version;
      } else {
      browser = browserObj.brand;
      //browserVersion = uanew.fullVersionList[1].version;
      browserVersion = browserObj.version;
      console.log('Browser:', browser);
      console.log('Browser Version:', browserVersion);
      }
    } else {
      console.log('BOT Detected!');
      browser = uanew.brands[1].brand;
      browserVersion = uanew.brands[1].version;
    }
    architecture = uanew.architecture;
    bitness = uanew.bitness;
    platform = uanew.platform;
    platformVersion = uanew.platformVersion;
  } else {
    // console.log("UserAgentData not supported");
    const ua = navigator.userAgent;
    const uaObj = parseUserAgent(ua);
    platform = uaObj.field1;
    bitness = uaObj.field2;
    architecture = uaObj.field3;
    browser = uaObj.field4;
    browserVersion = uaObj.field5;
  }
  if (navigator.deviceMemory) {
    deviceMemory = navigator.deviceMemory;
  }
  hardwareConcurrency = navigator.hardwareConcurrency;

  // Canvas FP
  function getCanvasFingerprint() {
    const canvas2d = document.createElement('canvas');
    canvas2d.width = 300;
    canvas2d.height = 150;
    const ctx = canvas2d.getContext('2d');
    ctx.textBaseline = 'alphabetic';
    ctx.font = "14px 'Arial'";
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);

    ctx.fillStyle = '#069';
    ctx.fillText('Browser Fingerprint', 2, 15);

    ctx.fillStyle = 'rgba(102,204,0,0.7)';
    ctx.fillText('Browser Fingerprint', 4, 17);

    ctx.beginPath();
    ctx.arc(50, 50, 25, 0, Math.PI * 2, true);
    ctx.closePath();
    ctx.fill();

    ctx.globalCompositeOperation = 'multiply';

    ctx.fillStyle = 'rgb(255,0,255)';
    ctx.beginPath();
    ctx.arc(50, 50, 30, 0, Math.PI * 2);
    ctx.fill();

    ctx.fillStyle = 'rgb(0,255,255)';
    ctx.beginPath();
    ctx.arc(70, 50, 30, 0, Math.PI * 2);
    ctx.fill();

    // Canvas data
    const data = canvas2d.toDataURL();
    return data;
  }

  canvasFP = getCanvasFingerprint();
  // console.log("canvasFP:",canvasFP);
  if (!canvasFP) {
    console.log('BOT Detected by Canvas!');
  }
  // DF Logic
  // Canvas for WebGL fingerprint
  const webglCanvas = document.createElement('canvas');
  const gl = webglCanvas.getContext('webgl');
  const ext = gl.getExtension('WEBGL_debug_renderer_info');

  const fp = {
    vendor: ext
      ? gl.getParameter(ext.UNMASKED_VENDOR_WEBGL)
      : gl.getParameter(gl.VENDOR),

    renderer: ext
      ? gl.getParameter(ext.UNMASKED_RENDERER_WEBGL)
      : gl.getParameter(gl.RENDERER),

    version: gl.getParameter(gl.VERSION),

    shading: gl.getParameter(gl.SHADING_LANGUAGE_VERSION),
  };

  console.log('New FP', fp);

  const rendererInfo = fp.renderer;
  const match = rendererInfo.match(/^ANGLE \(.*\)(?=,|$)/);

  renderer = match ? match[0] : rendererInfo;

  console.log(renderer);

  winLength = Object.keys(window).length;
  maxTouchpoints = navigator.maxTouchPoints;
  pixelratio = window.devicePixelRatio;

  const dfObject = {
    browserName: browser,
    browserVersion: browserVersion,
    platform: platform,
    platformVersion: platformVersion,
    bit: bitness,
    architecture: architecture,
    memory: deviceMemory,
    threads: hardwareConcurrency,
    graphics: renderer,
    pixelratio: pixelratio,
    winLength: winLength,
    touchpoints: maxTouchpoints,
    canvas: canvasFP,
  };

  async function createDfp(fingerprintData) {
    const data = JSON.stringify(fingerprintData);

    const hashBuffer = await crypto.subtle.digest(
      'SHA-256',
      new TextEncoder().encode(data),
    );
    const browserFingerprint = Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');

    return browserFingerprint;
  }

  try {
    dfp = await createDfp(dfObject);
    console.log('BrowserFingerprint:', dfp);
  } catch (e) {
    console.log('Error in Fingerprinting:', e);
  }
  return dfp;
}
// Register function: takes values from the user
/* un is nothing the userId which would be registered and uniquely identified
mid : MerchantID provided by AShield team
merTxnId : TransactionID created for this request for further reference
onError and onSuccess or just callback functions invoked accordingly 
*/
export async function registerUser(
  rmn,
  mid,
  merTxnId,
  rdUrl,
  signature,
  cusHeaders,
  onError,
  onSuccess,
) {
  let msg = 'Unexpected error';
  // Data passing for preregister
  try {
    let status = 0;
    // let jwt = "";
    let asn = '';
    let thresholdLength = 243;
    let headers = {
      'Content-Type': 'application/json',
      'x-sdk-type': 'web',
      'x-sdk-ver': '1.003',
    };
    Object.assign(headers, cusHeaders);
    printlog('rdUrl: ', { url: rdUrl });
    if (!signature || 0 == signature.length) {
      onError('CL_ERR_1001', 'Invalid Registration request');
      return;
    }
    if (10 > rmn.length) {
      onError('CL_ERR_1001', 'Invalid Registration request');
      return;
    }
    //  if (10 == rmn.length) {
    //    rmn = "91" + rmn;
    //  } else if (11 == rmn.length) {
    //    rmn = "91" + rmn.substring(1, 11);
    //  } else if (13 == rmn.length) {
    //    rmn = rmn.substring(1, 13);
    //  }
    let epuk = localStorage.getItem(rmn + '_' + 'epuk');
    let epik = localStorage.getItem(rmn + '_' + 'epik');
    let eshare = localStorage.getItem(rmn + '_' + 'share');
    let etxnId = localStorage.getItem(rmn + '_' + 'txnId');
    if (eshare && etxnId) {
      printlog('Already registered User. ');
      onError('AS1002', 'User is already registered');
      return;
    }
    if (null == epuk || 0 == epuk.length) {
      // Create public-private key pair
      try {
        let keypar = await window.crypto.subtle.generateKey(
          {
            name: 'RSA-OAEP',
            modulusLength: 4096,
            publicExponent: new Uint8Array([1, 0, 1]),
            hash: algo,
          },
          true,
          ['encrypt', 'decrypt'],
        );
        let ek = await window.crypto.subtle.exportKey('spki', keypar.publicKey);
        epuk = arrayBufferToBase64(ek);
        localStorage.setItem(rmn + '_' + 'epuk', epuk);

        let epk = await window.crypto.subtle.exportKey(
          'pkcs8',
          keypar.privateKey,
        );

        epik = arrayBufferToBase64(epk);
        localStorage.setItem(rmn + '_' + 'epik', epik);
      } catch (exp) {
        // Throw error
        logger.error('Error occurred during registration:', exp);
        onError('AS1003', 'Client Error. ' + exp.message);
        return;
      }
    }
    // localStorage.setItem(un + "_" + "cid",  credential.id);
    epuk = localStorage.getItem(rmn + '_' + 'epuk');
    // PUK Must be sent as part of request
    // So must wait for above promises
    const df = await getDeviceIntelligence();
    const credentialData = {
      regnum: rmn,
      epuk: epuk,
      mid: mid,
      merTxnId: merTxnId,
      origin: window.location.hostname,
      rdUrl: rdUrl,
      signature: signature,
      df: df,
    };
    printlog('Calling AShield server preregister api...');
    let preregisterResponse = await fetch(
      serverBaseUrl + '/web/browser/preregister',
      {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(credentialData),
      },
    );

    let serverPreRegisterResponse = await preregisterResponse.json();
    msg = serverPreRegisterResponse.msg;
    status = serverPreRegisterResponse.status;
    const encryptedObj = serverPreRegisterResponse.resp; // Server passing JWT
    printlog('serverPreRegisterResponse: ', serverPreRegisterResponse);
    /*
    if (!serverPreRegisterResponse.ok) {
      logger.info('Registeration failed!');
      logger.trace(
        'Server response: ' + JSON.stringify(serverPreRegisterResponse),
      );
      onError(
        'AS1002',
        'Registration failed. Unable to process Registration request',
      );
      return;
    }
*/
    if (status == 4102) {
      // Show error message
      onError(
        'AS1002',
        'Registration failed. Unable to process Registration request',
      );
      return;
    }
    const decryptedResponse = await decryptResponse(epik, encryptedObj);
    const preRegObj =
      typeof decryptedResponse === 'string'
        ? JSON.parse(decryptedResponse)
        : decryptedResponse;

    console.log('Pre Register Object: ', preRegObj);
    thresholdLength = preRegObj.winLength;
    // asn = preRegObj.asn;
    const asnObj = {
      asn: preRegObj.asn,
      as_name: preRegObj.as_name,
      as_domain: preRegObj.as_domain,
      country_code: preRegObj.country_code,
      country: preRegObj.country,
      continent_code: preRegObj.continent_code,
      continent: preRegObj.continent,
    };
    console.log('ASN Object: ', asnObj);

    //  thresholdLength = await decryptResponse(epik,encryptedThreshold);
    //  asn = await decryptResponse(epik,encryptedASN);
    /*Browser Detection Part*/
    let ua = navigator.userAgent;
    // let canMobile = /iPhone|iPad|Android/i.test(navigator.userAgent);
    let canMobile = isMobileDevice();
    let fraudScore = 0;
    let webDriverFlag = navigator.webdriver;
    let isMobile = false;

    if (canMobile) {
      isMobile = true;
    }
    if (webDriverFlag) {
      fraudScore += 50;
    }
    if (navigator.mimeTypes && navigator.mimeTypes.length === 0 && !isMobile) {
      fraudScore += 25;
    }
    if (navigator.plugins.length === 0 && !isMobile) fraudScore += 20;
    if (navigator.getBattery) {
      const battery = await navigator.getBattery();
      // If charging and level is 100% and stays exactly 100%, it might be a server
      if (
        battery.level === 1 &&
        battery.charging &&
        battery.chargingTime === 0
      ) {
        fraudScore += 20;
      }
    }
    if (isMobile && navigator.maxTouchPoints === 0) {
      fraudScore += 50;
    }

    if (window.screen.width === 0 || window.outerWidth === 0) {
      fraudScore += 50;
    }
    // PRESENT ONLY IN MODERN BROWSERS
    if (navigator.userAgentData) {
      const brandArray = navigator.userAgentData.brands;
      let isChrome = brandArray.some((obj) => obj.brand === 'Google Chrome');
      console.log('IsChrome: ', isChrome);
      console.log('TouchPoint: ', navigator.maxTouchPoints);
      console.log('TCHPNT :', window.clientInformation.maxTouchPoints);
      console.log('PixelRatio :', window.devicePixelRatio);
      console.log('Window length: ', Object.keys(window).length);
      console.log('IsMobile: ', isMobile);
      console.log('Network Info', navigator.connection);

      if (isChrome && Object.keys(window).length > thresholdLength) {
        // CHROME HEADED BROWSER
        fraudScore += 100;
      } else if (
        brandArray.length < 3 &&
        navigator.maxTouchPoints == 0 &&
        window.devicePixelRatio < 2
      ) {
        // Headless Browser
        fraudScore += 100;
      }
    }

    // WebAuthn Capability check for mobile browsers
    if (isMobile) {
      const responseCode = await checkWebAuthnCapability();
      if (responseCode == 'CL_ERR_1005' || responseCode == 'CL_ERR_1006') {
        fraudScore += 100; // TESTING REQUIRED - Genuine password off case
      }
      /*else {
        onError('AS1004', 'Wrong Device in registration');
        return;
      }
      */
    }

    //Returning from SDK Only //

    if (fraudScore >= 100) {
      // High Possibility of BOT
      printlog('AS1005: Bot Request');
      onError('AS1005', 'Bot request');
      return;
    }
    /* Calling Register API */
    printlog('Calling AShield server register api...');
    headers = {
      'Content-Type': 'application/json',
      'x-sdk-type': 'web',
      'x-sdk-ver': '1.003',
    };
    const regData = {
      regnum: rmn,
      mid: mid,
      merTxnId: merTxnId,
      origin: window.location.hostname,
      asn: asnObj,
      rdUrl: rdUrl,
      signature: signature,
      df: df,
      epuk: epuk,
    };
    let registerResponse = await fetch(
      serverBaseUrl + '/web/browser/register',
      {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(regData),
      },
    );

    let serverRegisterResponse = await registerResponse.json();
    msg = serverRegisterResponse.msg;
    status = serverRegisterResponse.status;
    let isAnonymus = serverRegisterResponse.anonymus;
    printlog('Reg response: serverRegisterResponse: ', serverRegisterResponse);

    if (!registerResponse.ok) {
      logger.info('Registeration failed!');
      logger.trace(
        'Server response: ' + JSON.stringify(serverRegisterResponse),
      );
      onError(
        'AS1002',
        'Registration failed. Unable to process Registration request',
      );
      return;
    }
    if (status == 4102) {
      // Show error message
      onError(
        'AS1002',
        'Registration failed. Unable to process Registration request',
      );
      return;
    }
    if (isAnonymus) {
      onError('AS1006', 'VPN Active. Possible vulnerability.');
      return;
    }
    //let url = await decryptResponse(epik, serverRegisterResponse.resp);
    let url = serverRegisterResponse.resp;
    printlog('fraudScore:', { fraudScore: fraudScore });
    // window.location.href = url;
    return url;
  } catch (error) {
    logger.error('Error occurred during registration:', error);
    onError('AS1003', 'Client Error. ' + error.message);
  }
}

// Authenticate the user

// AuthenticateUser function: takes values from the user
/* rmn is the userId which was registered earlier and uniquely identified
mid : MerchantID provided by AShield team
merTxnId : TransactionID created for this request for further reference
signature : generate the signature as per the  generate signature reference
onError and onSuccess or just callback functions invoked accordingly 
*/
export async function authenticateUser(
  rmn,
  mid,
  merTxnId,
  signature,
  cusHeaders,
  onError,
  onSuccess,
  rdurl,
  // serverBaseUrl
) {
  // Generate a challenge (random string)
  try {
    let headers = {
      'Content-Type': 'application/json',
      'x-sdk-type': 'web',
      'x-sdk-ver': '1.003',
    };
    if (!signature || 0 == signature.length) {
      onError('AS2001', 'Invalid authentication request');
      return;
    }

    if (10 > rmn.length) {
      onError('AS2001', 'Invalid authentication request');
      return;
    }
    //  if (10 == rmn.length) {
    //    rmn = "91" + rmn;
    //  } else if (11 == rmn.length) {
    //    rmn = "91" + rmn.substring(1, 11);
    //  } else if (13 == rmn.length) {
    //    rmn = rmn.substring(1, 13);
    //  }
    Object.assign(headers, cusHeaders);
    let msg = 'Unexpected Error';
    let status = 0;
    let thresholdLength = 243;
    let epuk = localStorage.getItem(rmn + '_' + 'epuk');
    let epik = localStorage.getItem(rmn + '_' + 'epik');
    let ua = navigator.userAgent;
    let canMobile = isMobileDevice();
    let fraudScore = 0;
    let webDriverFlag = navigator.webdriver;
    let isMobile = false;

    if (canMobile) {
      isMobile = true;
    }
    const df = await getDeviceIntelligence();
    //old
    let asAuthData = {
      share: localStorage.getItem(rmn + '_' + 'share'),
      txnId: localStorage.getItem(rmn + '_' + 'txnId'),
      regnum: rmn,
      mid: mid,
      merTxnId: merTxnId,
      signature: signature,
      origin: window.location.hostname,
      silentauth: true,
      df: df,
    };
    if (null == epuk || null == epik) {
      // Unexpected error throw exception
      onError('AS2006', 'Invalid Input. Register and try again');
      //  onError("User verification is must. Unexcepted error");
    } else {
      // Perform the server authenticate request
      let sresp = await fetch(serverBaseUrl + '/web/browser/authenticate', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(asAuthData),
      });
      let serverAuthenticateResponse = await sresp.json();
      msg = serverAuthenticateResponse.msg;
      status = serverAuthenticateResponse.status;
      thresholdLength = serverAuthenticateResponse.winLength;
      printlog('Auth response: ', serverAuthenticateResponse);
      /*
	if (!sresp.ok) {
        logger.info('Authentication failed!');
        logger.trace(
          'Server Authentication Response: ' +
            JSON.stringify(serverAuthenticateResponse),
        );
        onError('AS2002', 'Authentication Failed. Try Registration again.');
        return;
      }
      */
      if (status == 4302) {
        onError('AS2002', 'Authentication Failed. Try Registration again.');
        return;
      }

      // BROWSER CHECKS
      if (webDriverFlag) {
        fraudScore += 50;
      }
      if (navigator.getBattery) {
        const battery = await navigator.getBattery();
        // If charging and level is 100% and stays exactly 100%, it might be a server
        if (
          battery.level === 1 &&
          battery.charging &&
          battery.chargingTime === 0
        ) {
          fraudScore += 20;
        }
      }
      if (isMobile && navigator.maxTouchPoints === 0) {
        fraudScore += 50;
      }

      if (window.screen.width === 0 || window.outerWidth === 0) {
        fraudScore += 30;
      }
      // PRESENT ONLY IN MODERN BROWSERS
      if (navigator.userAgentData) {
        const brandArray = navigator.userAgentData.brands;
        let isChrome = brandArray.some((obj) => obj.brand === 'Google Chrome');
        console.log('IsChrome: ', isChrome);
        console.log('TouchPoint: ', navigator.maxTouchPoints);
        console.log('TCHPNT :', window.clientInformation.maxTouchPoints);
        console.log('PixelRatio :', window.devicePixelRatio);
        console.log('Window length: ', Object.keys(window).length);
        console.log('IsMobile: ', isMobile);

        if (isChrome && Object.keys(window).length > thresholdLength) {
          // CHROME HEADED BROWSER
          fraudScore += 100;
        } else if (
          brandArray.length < 3 &&
          navigator.maxTouchPoints == 0 &&
          window.devicePixelRatio < 2
        ) {
          // Headless Browser
          fraudScore += 100;
        }
      }
      // WebAuthn Capability check for mobile browsers
      if (isMobile) {
        const responseCode = await checkWebAuthnCapability();
        if (responseCode == 'CL_ERR_1005' || responseCode == 'CL_ERR_1006') {
          fraudScore += 100; // TESTING REQUIRED - Genuine password off case
        }
        /* else {
          onError('A2004', 'Wrong Device in reauthentication');
          return;
        } */
      }
      if (fraudScore >= 100) {
        onError('AS2005', 'BOT request in reauth');
        return;
      }
      printlog('fraudScore:', { fraudScore: fraudScore });
      if (serverAuthenticateResponse.resp) {
        let epik = localStorage.getItem(rmn + '_' + 'epik');
        if (undefined == epik || 0 == epik.length) {
          onError('AS2002', 'Reauthentication failed. No private Key found');
          return;
        }
        let url = await processAsResp(
          rmn,
          JSON.parse(serverAuthenticateResponse.resp),
          rdurl,
        );
        return url;
        // onSuccess("Authenticated");
      }
    }
  } catch (error) {
    logger.error('Error occurred during authentication:', error);
    onError('AS2003', 'Client Error. ' + error.message);
  }
}

export async function processResp(rdResp, onError, onSuccess) {
  if (null == rdResp || 0 == rdResp.length) {
    onError('AS1002', 'Registration failed. Empty response');
    return;
  }
  let abResp = toArrayBuffer(rdResp);
  let strResp = arrayBufferToString(abResp);

  let jsonResp = JSON.parse(strResp);
  printlog('Process Response ', jsonResp);
  let status = jsonResp.status;
  let msg = jsonResp.msg;
  if (status !== 20001) {
    onError(
      'AS1008',
      'Registration failed. Unable to process Registration request',
    );
    return;
  }
  let un = jsonResp.un;
  let asTxnId = jsonResp.asTxnId;
  let encdata = jsonResp.eshare;
  let epik = localStorage.getItem(un + '_' + 'epik');

  if (undefined == epik || 0 == epik.length) {
    onError('AS1007', 'Registration failed. Registration not initiated');
    return;
  }
  let share = await decryptResponse(epik, encdata);
  localStorage.setItem(un + '_' + 'txnId', asTxnId);
  localStorage.setItem(un + '_' + 'share', share);
  onSuccess('Registered');
}

async function processAsResp(un, resp, rdurl) {
  if ('eshare' in resp) {
    let encdata = resp.eshare;
    let epik = localStorage.getItem(un + '_' + 'epik');
    // if (undefined == epik || 0 == epik.length) {
    //   onError('AS2002', 'Reauthentication failed. No private Key found');
    //   return;
    // }
    let share = await decryptResponse(epik, encdata);
    localStorage.setItem(un + '_' + 'txnId', resp.asTxnId);
    localStorage.setItem(un + '_' + 'share', share);
    const url = rdurl + `?resp=authSuccess&regnum=${un}`;
    return url;
  }
}
